import { Field } from '@chakra-ui/react';
import { forwardRef } from 'react';

import { FieldWrapperDefaultProps, type FieldWrapperProps } from './FieldWrapper.types';

const FieldWrapper = forwardRef<HTMLDivElement, FieldWrapperProps>(
  ({ children, label, hint, error, invalid, id, labelWidth, ...props }, ref) => {
    return (
      <Field.Root ref={ref} invalid={!!error || invalid} {...props}>
        {label && (
          <Field.Label
            htmlFor={id}
            textTransform="capitalize"
            minWidth={props.orientation === 'horizontal' ? (labelWidth ?? '30%') : undefined}
          >
            {label}
            <Field.RequiredIndicator />
          </Field.Label>
        )}
        {children}
        {hint && !error && <Field.HelperText>{hint}</Field.HelperText>}
        {error && <Field.ErrorText>{error}</Field.ErrorText>}
      </Field.Root>
    );
  }
);

FieldWrapper.displayName = 'FieldWrapper';
FieldWrapper.defaultProps = FieldWrapperDefaultProps;

export { FieldWrapper };
